/* jshint esversion: 6 */
import React from 'react';
import * as _ from 'underscore';

 const TextareaEvents = {
    onTextareaKeyUp: function(e) {
        let textValue = e.target.value,
            urlCallback = null,
            serviceType = parseInt(e.currentTarget.dataset.servicetype) || 0,
            fieldName = e.target.name || '';

        if (this.props.getUrlPreview) {
            urlCallback = this.props.getUrlPreview;
        } else if (this.getUrlPreview) {
            urlCallback = this.getUrlPreview;
        }

        window.clearTimeout(this.keyUpTimeout);

        // Paste was triggering both keyUp and Paste, so handle it in one with a flag
        // that determines the immediacy of the detection also debounces text input
        if (!this.keyUpPasteFlag) {
            this.keyUpTimeout = window.setTimeout(() => {
                urlCallback(textValue, serviceType, fieldName);
                this.keyUpTimeout = 0;
            }, 1000);
        } else {
            this.keyUpPasteFlag = false;
        }

    },

    onTextareaPaste: function(e) {
        e.stopPropagation();

        let data = '',
            urlCallback = null,
            serviceType = parseInt(e.currentTarget.dataset.servicetype) || 0,
            fieldName = e.target.name || '';

        if (fieldName) {
            e.preventDefault();
        }

        if (this.props.getUrlPreview) {
            urlCallback = this.props.getUrlPreview;
        } else if (this.getUrlPreview) {
            urlCallback = this.getUrlPreview;
        }

        this.keyUpPasteFlag = true;
        if ((data = e.clipboardData.getData('text/plain')) !== '') {
            urlCallback(data, serviceType, fieldName);
        }
    }
};


export default TextareaEvents;
